export const UPDATE_WHITELIST_FILTERS = 'UPDATE_WHITELIST_FILTERS';
export const FETCH_WHITELIST = 'FETCH_WHITELIST';
export const FETCH_WHITELIST_SUCCESS = 'FETCH_WHITELIST_SUCCESS';
export const FETCH_WHITELIST_FAIL = 'FETCH_WHITELIST_FAIL';
export const CHANGE_WHITELIST_PAGE = 'CHANGE_WHITELIST_PAGE';
export const CHANGE_WHITELIST_PAGE_SIZE = 'CHANGE_WHITELIST_PAGE_SIZE';
export const RELOAD_WHITELIST = 'RELOAD_WHITELIST';

export const fetchWhiteList = ({ searchText, currentPage, pageSize }) => ({
  type: FETCH_WHITELIST,
  payload: { searchText, currentPage, pageSize }
});

export const fetchWhiteListSuccess = ({ whitelistData, total }) => ({
  type: FETCH_WHITELIST_SUCCESS,
  payload: { whitelistData, total }
});

export const fetchWhiteListFail = () => ({
  type: FETCH_WHITELIST_FAIL
});

export const changeWhiteListPage = (currentPage) => ({
  type: CHANGE_WHITELIST_PAGE,
  payload: currentPage
});

export const changeWhiteListPageSize = (pageSize) => ({
  type: CHANGE_WHITELIST_PAGE_SIZE,
  payload: pageSize
});

export const reloadWhiteList = () => ({
  type: RELOAD_WHITELIST
});

export const updateWhiteListFilters = (searchText) => ({
  type: UPDATE_WHITELIST_FILTERS,
  payload: searchText
});
